// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var VolatilityLabSide;
(function (VolatilityLabSide) {
    VolatilityLabSide[VolatilityLabSide["Calls"] = 0] = "Calls";
    VolatilityLabSide[VolatilityLabSide["Puts"] = 1] = "Puts";
    VolatilityLabSide[VolatilityLabSide["CallsAndPuts"] = 2] = "CallsAndPuts";
})(VolatilityLabSide || (VolatilityLabSide = {}));
export function getVolatilityLabSideKey(value) {
    switch (value) {
        case VolatilityLabSide.Calls:
            return 'property.Calls';
        case VolatilityLabSide.Puts:
            return 'property.Puts';
        case VolatilityLabSide.CallsAndPuts:
            return 'property.CallsAndPuts';
        default:
            return '';
    }
}
